import React from 'react';

import {Badge, Icon, LoadingSpinner, Text} from '@albert-io/atomic';
import {history} from 'client/history';

import {useHomeAdaptiveSubjects} from '../hooks/useHomeAdaptiveSubjects';

const DESCRIPTION =
  'Build personalized sequences of skills for your students to master. Pick a subject to start.';

/**
 * "Create Adaptive Skill Paths" card, shown in both Home states.
 */
export const AdaptiveSkillPathsCard = () => {
  const {subjects, loading} = useHomeAdaptiveSubjects();

  const renderBody = () => {
    if (subjects.length > 0) {
      return (
        <ul className='m-x0 gap-x1 p-x0 flex list-none flex-wrap'>
          {subjects.map((subject) => (
            <li className='flex' key={subject.id}>
              <Badge
                emphasis='subtle'
                icon='arrow-up-right'
                iconAlign='right'
                iconStyle='regular'
                onClick={() => history.pushState(null, `/adaptive-subjects/${subject.urlSlug}`)}
                status='info'
              >
                {subject.name}
              </Badge>
            </li>
          ))}
        </ul>
      );
    }
    if (loading) {
      return <LoadingSpinner assistiveText='Loading adaptive subjects…' bottomMarginLevel={0} />;
    }
    return null;
  };

  return (
    <section
      aria-label='Create Adaptive Skill Paths'
      className='gap-x2 rounded-x1-half border-border-primary background-primary p-x3 flex border'
    >
      <span className='h-x5 w-x5 rounded-x1 background-special-subtle content-special flex shrink-0 items-center justify-center text-xl'>
        <Icon color='inherit' icon='sparkles' iconStyle='light' size='inherit' />
      </span>
      <div className='gap-x1-half flex min-w-0 grow flex-col'>
        <div className='gap-x0-quarter flex flex-col'>
          <Text>Create Adaptive Skill Paths</Text>
          <Text color='tertiary' size='s'>
            {DESCRIPTION}
          </Text>
        </div>
        {renderBody()}
      </div>
    </section>
  );
};
